/**
 * Sentence splitting for the widget (browser-TTS boundary mapping, translation
 * batches): the same function the server uses for sentence cache keys.
 */
export { splitIntoSentences } from '../../lib/sentenceSplit';
